import { useMemo } from "react";
import { useWorkspaceCustomFields } from "#app/hooks/use-workspace-custom-fields";

/** The workspace custom-field pool minus the fields already on the issue —
 *  what the add-field pickers offer. */
export function useAvailableCustomFields(existingFieldIds: string[]) {
  const fields = useWorkspaceCustomFields();

  return useMemo(() => {
    const existingSet = new Set(existingFieldIds);
    return fields.filter((field) => !existingSet.has(field.customFieldId));
  }, [fields, existingFieldIds]);
}
